import { NUMBER_1, NUMBER_2, NUMBER_3, NUMBER_4, NUMBER_5, NUMBER_6 } from '~shared/constants';

export enum CancellationReasons {
  NO_INVENTORY = NUMBER_1,
  WRONG_PRICE = NUMBER_2,
  WRONG_PRODUCT_DATA = NUMBER_3,
  FRAUD_SUSPICIOUS = NUMBER_4,
  FRAUD_CHECK_OUT_OF_STOCK = NUMBER_5,
  CANCELLED_BY_CUSTOMER_SUPPORT = NUMBER_6,
}
